import { render } from "./Investors.vue?vue&type=template&id=01eead67&scoped=true"
import script from "./Investors.vue?vue&type=script&lang=js"
export * from "./Investors.vue?vue&type=script&lang=js"

import "./Investors.vue?vue&type=style&index=0&id=01eead67&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01eead67"]])

export default __exports__